var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CheckBadgeIcon } from "@heroicons/react/24/outline";
import { useContext, useState } from "@wordpress/element";
import { __ } from "@wordpress/i18n";
import { Loading } from "../../../../../components/Loading/Loading";
import { UPDATE_USER_PAGE_TASK_DONE } from "../../../../constants";
import { useTaskActions } from "../../../../hooks/actions/useTaskActions";
import { UserPageAppContext } from "../../../../providers/UserPageAppContextProvider";
import { UserPageTaskContext } from "../../../../providers/UserPageTaskContextProvider";
function TaskDoneStatus({ task }) {
    const { changeTaskDoneStatus } = useTaskActions();
    const [loading, setLoading] = useState(false);
    const { userTaskDispatch } = useContext(UserPageTaskContext);
    const { state: { userId }, } = useContext(UserPageAppContext);
    const isAssigned = task === null || task === void 0 ? void 0 : task.assigned_users.some((user) => user.id === userId);
    const isDone = task.is_done;
    const doneMessage = isDone
        ? __("Task is completed", "quicktasker")
        : __("Task is incomplete", "quicktasker");
    const handleDoneStatusChange = (done) => __awaiter(this, void 0, void 0, function* () {
        setLoading(true);
        yield changeTaskDoneStatus(task.task_hash, done, () => {
            userTaskDispatch({
                type: UPDATE_USER_PAGE_TASK_DONE,
                payload: { done },
            });
        });
        setLoading(false);
    });
    if (!isAssigned) {
        return null;
    }
    return (_jsxs("div", { className: "wpqt-mt-2 wpqt-mb-2 wpqt-flex wpqt-flex-col wpqt-items-center", children: [_jsx("div", { className: "wpqt-font-medium", children: doneMessage }), _jsx("div", { className: "wpqt-text-gray-400 wpqt-text-sm wpqt-mb-2", children: __("Click to change", "quicktasker") }), loading ? (_jsx(Loading, { ovalSize: "36" })) : isDone ? (_jsx(CheckBadgeIcon, { className: "wpqt-size-9 wpqt-icon-green wpqt-cursor-pointer", onClick: () => {
                    handleDoneStatusChange(false);
                } })) : (_jsx(CheckBadgeIcon, { className: "wpqt-size-9 wpqt-text-gray-300 wpqt-cursor-pointer", onClick: () => {
                    handleDoneStatusChange(true);
                } }))] }));
}
export { TaskDoneStatus };
